import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Tooltip } from '@mui/material';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';

import { Icons } from '../../Themes';
import { Providers } from '../../Utils/Types';
import { getFacebookAppId } from '../../Utils/OAuth';
import CustomIcon from '../DesignSystem/CustomIcon';
import useSpace from '../../Hooks/useSpace';
import useCookieSettings from '../../Hooks/useCookieSettings';
import AuthCookieModal from './AuthCookieModal';
import AuthenticationButton from './Button';

const Button = ({ isSdkLoaded, onClick }: any) => (
  <Tooltip
    arrow
    disableHoverListener={isSdkLoaded}
    title={<FormattedMessage id="AUTH.FACEBOOK_LOAD_ERROR" />}
  >
    <div>
      <AuthenticationButton
        startIcon={<CustomIcon src={Icons.misc.facebookLoginIcon} size={24} color="#3B5998" />}
        provider="Facebook"
        onClick={onClick}
      >
        Facebook
      </AuthenticationButton>
    </div>
  </Tooltip>
);

function FacebookButton({ onClick }: any) {
  const { space } = useSpace();
  const { settings } = useCookieSettings();
  const [cookieModalOpen, setCookieModalOpen] = useState(false);
  const facebookAppId = getFacebookAppId(space);
  const cookieEnabled = settings.facebook;

  if (!facebookAppId) {
    return null;
  }

  const handleLogin = (payload: any) => {
    onClick(Providers.PROVIDER_NAME_FACEBOOK, payload);
  };

  return (
    <>
      {cookieEnabled ? (
        <FacebookLogin
          appId={facebookAppId}
          cookie
          fields="name,email"
          callback={handleLogin}
          render={({ isSdkLoaded, onClick }: any) => (
            <Button isSdkLoaded={isSdkLoaded} onClick={onClick} />
          )}
        />
      ) : (
        <Button onClick={() => setCookieModalOpen(true)} />
      )}
      <AuthCookieModal provider="facebook" open={cookieModalOpen} setOpen={setCookieModalOpen} />
    </>
  );
}

export default FacebookButton;
